//
// FIXME: This is not a React component, so the file should end in .ts, not .tsx.
//

import angular from 'angular';
import type { CartOrder, CartOrderManager, CartProfile } from 'cart-core';
import { getContentArea } from 'cart-core';
import { getSessionSponsorRcn } from 'sponsor-rcn-affiliate-links';
import SignUpAngularController from '../SignUpAngularController';

const messageNamespace = 'checkoutPreferredCustomer';

interface Response {
  messages;
}

class CheckoutPreferredCustomerController extends SignUpAngularController {
  public fieldMessages: {};
  public hasMessage: boolean;
  public haveSponsor: boolean;
  public myPage: string;
  public showFields: boolean;
  public showForm: boolean;
  public title: string;
  public titles: { [key: string]: string };
  public disclaimerMessage = this.$sce.trustAsHtml(getContentArea('checkoutPreferredCustomerDisclaimer') || '');

  constructor(
    public $sce: angular.ISCEService,
    public $location: any,
    public rcmEventManager: IRcmApiLibEventManager,
    public orderMgr: CartOrderManager,
    public checkoutEnrollment: any,
    public translateFilter: any,
    public termsDialog: any
  ) {
    super();

    this.order = this.orderMgr.getOrder();
    this.showForm = false;
    this.showFields = false;
    this.myPage = '/checkout/preferred-customer';
    this.titles = {
      convertUser: this.translateFilter('Upgrade to a Reliv Preferred Customer'),
      newUser: this.translateFilter('Create a New Reliv Preferred Customer Account'),
    };
    this.title = null;
    this.hasMessage = false;
    this.fieldMessages = {};
    this.haveSponsor = true;

    /**
     * on orderMgr.orderChange
     */
    rcmEventManager.on('orderMgr.orderChange', this.updateOrder, 'checkoutPreferredCustomer');

    // Only refresh if no order
    if (!this.orderMgr.hasOrder()) {
      this.orderMgr.refreshOrder();
    } else {
      this.updateOrder(this.orderMgr.getOrder());
    }
  }

  public shouldShowProfilePrimaryFields() {
    return this.showFields;
  }

  public shouldShowSponsorRcn() {
    return (
      !!this.order.attributes &&
      !this.order.attributes.signUpRules.preferredCustomer.requiredSponsorRcn &&
      this.haveSponsor !== false
    );
  }

  public handleHaveSponsorChanged = (value) => {
    if (value) {
      this.newProfile.sponsorRcn = '';
      this.sponsorRcnAgain = '';
    } else {
      this.newProfile.sponsorRcn = this.order.attributes.guestSignUpRules.sponsorRcn;
      this.sponsorRcnAgain = this.order.attributes.guestSignUpRules.sponsorRcn;
    }
  };

  public submit = () => {
    this.onSubmit();

    if (this.shouldCreateNewAccountRatherThanConvert()) {
      if (!this.verifySponsorRcn()) {
        return;
      }

      if (!this.verifyPassword()) {
        return;
      }

      this.checkoutEnrollment.createTempProfile(this.newProfile, this.onSubmitSuccess, this.onSubmitError);

      return;
    }

    this.checkoutEnrollment.updateTempProfile(this.newProfile, this.onSubmitSuccess, this.onSubmitError);
  };

  public showTerms = () => {
    this.termsDialog.showTerms(
      'newPreferredCustomer',
      this.order,
      this.newProfile,
      this.checkoutEnrollment.handleMessages
    );
  };

  public onSubmit = () => {
    this.hasMessage = false;
    this.checkoutEnrollment.clearMessages(messageNamespace);
  };

  public onSubmitSuccess = (response: Response) => {
    this.showForm = false;
    this.orderMgr.nextPage(true);
  };

  public onSubmitError = (response: Response) => {
    this.checkoutEnrollment.handleMessages(
      response.messages,
      this.setFieldMessages,
      this.onPrimaryMessage,
      messageNamespace
    );
  };

  public setFieldMessages = (messages) => {
    this.fieldMessages = messages;
  };

  public onPrimaryMessage = (messages) => {
    this.hasMessage = true;
  };

  public isMyPage = () => {
    return this.$location.path() === this.myPage;
  };

  public shouldCreateNewAccountRatherThanConvert = () => {
    return this.order.attributes.signUpRules.preferredCustomer.type === 'new-preferred-customer';
  };

  public buildNewCustomer = () => {
    this.title = this.titles.newUser;

    // get sponsorRcn from affiliate link system if it is set
    this.newProfile.sponsorRcn = getSessionSponsorRcn();

    /**
     * Populate the sponsor RCN with the required RCN if an RCN is required
     */
    if (this.order.attributes.signUpRules.preferredCustomer.requiredSponsorRcn) {
      this.newProfile.sponsorRcn = this.order.attributes.signUpRules.preferredCustomer.requiredSponsorRcn;
    }

    // Sync again field always
    this.sponsorRcnAgain = this.newProfile.sponsorRcn;

    this.newProfile.creationMethod = 'PreferredCustomer';
    this.buildPreferredCustomFields();

    this.showFields = true;
    this.showForm = true;
  };

  public buildConvertCustomer = (currentProfile: CartProfile) => {
    this.title = this.titles.convertUser;
    this.newProfile.rcn = currentProfile.rcn;
    this.newProfile.creationMethod = 'CustomerToPreferredCustomer';
    this.buildPreferredCustomFields();

    this.showFields = false;
    this.showForm = true;
  };

  public buildPreferredCustomFields = () => {
    this.newProfile.status = 'C';
    this.newProfile.rank = this.order.attributes.rankRules.defaultRankPreferredCustomer;
  };

  public initOrder = () => {
    // get TempProfile
    if (!this.order.attributes.signUpRules.preferredCustomer.signUpAllowed) {
      return;
    }

    if (this.shouldCreateNewAccountRatherThanConvert()) {
      this.buildNewCustomer();
    } else {
      this.buildConvertCustomer(this.order.attributes.currentUserRules.profile);
    }

    this.showForm = true;
  };

  public updateOrder = (order: CartOrder) => {
    if (this.isMyPage()) {
      this.order = order;
      this.initOrder();
    }
  };
}

angular
  .module('checkout')
  .controller('checkoutPreferredCustomer', [
    '$sce',
    '$location',
    'rcmEventManager',
    'orderMgr',
    'checkoutEnrollment',
    'translateFilter',
    'termsDialog',
    CheckoutPreferredCustomerController as angular.IControllerConstructor,
  ]);
